export default "__VITE_ASSET__CgmtRg4r__"